// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ByteOrder } from "./byte-order";
import { CommandAddress } from "./command-address";
import { CommandArg, CommandArgT, verifyCommandArg } from "./command-arg";
import { Key, KeyT } from "./key";

/**
 * One MCE command an LN2 control sends. A null `byte_order` in a profile
 * means product order; a table always carries it.
 */
export class CommandTarget implements flatbuffers.IUnpackableObject<CommandTargetT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): CommandTarget {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCommandTarget(bb: flatbuffers.ByteBuffer, obj?: CommandTarget): CommandTarget {
    return (obj || new CommandTarget()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsCommandTarget(
    bb: flatbuffers.ByteBuffer,
    obj?: CommandTarget,
  ): CommandTarget {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new CommandTarget()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new Key()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  address(): CommandAddress {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : CommandAddress.Unspecified;
  }

  byteOrder(): ByteOrder | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  args(index: number, obj?: CommandArg): CommandArg | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new CommandArg()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  argsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startCommandTarget(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addAddress(builder: flatbuffers.Builder, address: CommandAddress) {
    builder.addFieldInt8(1, address, CommandAddress.Unspecified);
  }

  static addByteOrder(builder: flatbuffers.Builder, byteOrder: ByteOrder) {
    builder.addFieldInt8(2, byteOrder, null);
  }

  static addArgs(builder: flatbuffers.Builder, argsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, argsOffset, 0);
  }

  static createArgsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startArgsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endCommandTarget(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    return offset;
  }

  static createCommandTarget(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    address: CommandAddress,
    byteOrder: ByteOrder | null,
    argsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    CommandTarget.startCommandTarget(builder);
    CommandTarget.addKey(builder, keyOffset);
    CommandTarget.addAddress(builder, address);
    if (byteOrder !== null) CommandTarget.addByteOrder(builder, byteOrder);
    CommandTarget.addArgs(builder, argsOffset);
    return CommandTarget.endCommandTarget(builder);
  }

  unpack(): CommandTargetT {
    return new CommandTargetT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.address(),
      this.byteOrder(),
      this.bb!.createObjList<CommandArg, CommandArgT>(this.args.bind(this), this.argsLength()),
    );
  }

  unpackTo(_o: CommandTargetT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.address = this.address();
    _o.byteOrder = this.byteOrder();
    _o.args = this.bb!.createObjList<CommandArg, CommandArgT>(
      this.args.bind(this),
      this.argsLength(),
    );
  }

  unpackFields(...fields: string[]): CommandTargetT {
    const t = new CommandTargetT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("address")) {
      t.address = this.address();
    }
    if (fieldSet.has("byte_order")) {
      t.byteOrder = this.byteOrder();
    }
    if (fieldSet.has("args")) {
      t.args = this.bb!.createObjList<CommandArg, CommandArgT>(
        this.args.bind(this),
        this.argsLength(),
      );
    }
    return t;
  }
}

export class CommandTargetT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: KeyT | null = null,
    public address: CommandAddress = CommandAddress.Unspecified,
    public byteOrder: ByteOrder | null = null,
    public args: CommandArgT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    const args = CommandTarget.createArgsVector(builder, builder.createObjectOffsetList(this.args));

    return CommandTarget.createCommandTarget(
      builder,
      this.key !== null ? this.key!.pack(builder) : 0,
      this.address,
      this.byteOrder,
      args,
    );
  }

  clone(): CommandTargetT {
    const obj = new CommandTargetT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.address = this.address;
    obj.byteOrder = this.byteOrder;
    obj.args = this.args.map((e) => e.clone());
    return obj;
  }

  equals(other: CommandTargetT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.address !== other.address) return false;
    if (this.byteOrder !== other.byteOrder) return false;
    if (this.args.length !== other.args.length) return false;
    for (let i = 0; i < this.args.length; i++) {
      const a = this.args[i];
      const b = other.args[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyCommandTarget(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 12);
    verifier.checkRequiredField(tablePos, 4, "key");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyCommandArg);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
